export const aciNightclub = {
    iconName: 'nightclub',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    d: 'M3 14.473a7.2 7.2 0 1014.4 0 7.2 7.2 0 00-14.4 0v0z',
                    stroke: 'currentColor',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M10.497 21.66c1.94-1.183 3.302-3.956 3.302-7.19 0-3.232-1.365-6.013-3.309-7.193M10.2 7.272v-3.6M9.9 21.661c-1.94-1.183-3.302-3.957-3.302-7.19 0-3.232 1.365-6.014 3.31-7.194M16.2 3.672v2.4M15 4.871h2.4M19.799 7.273v2.4M18.6 8.473H21',
                    stroke: 'currentColor',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M3 14.47c0 .316.186.628.548.919.362.29.892.556 1.56.778.67.223 1.463.4 2.337.52.873.121 1.81.183 2.755.183.946 0 1.882-.062 2.755-.182.874-.121 1.668-.298 2.336-.52.669-.223 1.2-.488 1.56-.78.363-.29.549-.602.549-.918 0-.315-.186-.627-.548-.918-.362-.291-.892-.556-1.56-.779-.67-.223-1.463-.4-2.337-.52-.873-.12-1.81-.183-2.755-.183-.946 0-1.882.062-2.755.183-.874.12-1.668.297-2.336.52-.669.223-1.2.488-1.56.779-.363.291-.549.603-.549.918v0z',
                    stroke: 'currentColor',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
